import { Dispatch, SetStateAction, useCallback } from 'react'
import { ScheduleType } from 'types/schedule'
import { FirebaseDocRefType } from 'firebase/index'
import { StockUnionType } from 'types/stock'
import { getInitialScheduleValue } from 'reducks/schedule/selectors'

const useToggleScheduleType = (
  breadRef: FirebaseDocRefType,
  storeRef: FirebaseDocRefType,
  openDeleteScheduleCautionModal: (type: StockUnionType) => void,
  setSchedules: Dispatch<SetStateAction<ScheduleType[]>>,
  setIsType: Dispatch<SetStateAction<boolean>>,
  type: StockUnionType
): (() => void) => {
  return useCallback(() => {
    setIsType((prevState) => {
      if (prevState) {
        openDeleteScheduleCautionModal(type)
        return true
      } else {
        setSchedules([getInitialScheduleValue(breadRef, storeRef.collection('store_schedules').doc(), type)])
        return !prevState
      }
    })
  }, [breadRef, storeRef, openDeleteScheduleCautionModal, setSchedules, setIsType, type])
}

export default useToggleScheduleType
